module.exports = __webpack_public_path__ + "media/components/src/assets/images/line_5-4a4eaa778714df269c756d0ccd4a95f9.jpg";